module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-10"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-10"
    }
  }, [_vm._v("Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" can’t believe she lied to us,” Tommy says as he joins me outside, letting the front door fall closed behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t believe you fell for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gives me a sideways glance as he sits beside me on the front porch swing, my favorite part of this old house. I lean over and kiss his neck. “There’s no way in hell Sofia would give up going to the party of the year just because CeCe wasn’t allowed to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But they’re best friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even best friends have to draw the line somewhere.” I put my hand on his leg, hoping my touch comforts him. Thanks to my parents, I learned early in life that it’s easy to be let down when your expectations of people are too high.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was it really the party of the year?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh yeah,” I say. “I mean, a party at Liam Donnelly’s is already pretty awesome, but a party at Liam Donnelly’s when his parents are out of town?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("“What’s the big deal about this kid?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s a junior, and she’s a freshman with a crush.” I smile, happy to be the one with an inside scoop for once. Our regular mani-pedi dates have become somewhat less regular, but last week as CeCe and I got our fingers and toes pampered, it was “Liam this” and “Liam that” and “Liam said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Interesting,” Tommy says. “Did I tell you they were slow dancing when I walked in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How slow?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shakes his head. “Real slow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Show me.” I stand and reach for Tommy’s hand. He resists at first, but eventually gives in like he always does. I put my arms around his neck and he brings his hands to my waist. “Were they standing like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A little closer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like this?” I take a step toward him and start swaying even though there isn’t any music and the neighbors might be watching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like that,” Tommy says with a sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sigh, too, but mine is a happy one, because there’s no place I’d rather be than here with him, slow dancing under the moonlight. We should dance more often; the last time might have been at Jack and Blake’s wedding last fall. Too long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I start humming “It Had to Be You,” the song we declared as ours. He joins in and I’m standing in the arms of the man I love, wondering if life can get any better than this. “I love you,” I whisper into his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then will you marry me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never.” I smile, resting my head on his chest. “But thank you for asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy laughs and the vibrations pass through his body "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("into mine. But then the laugh becomes a fit of coughs and I pull back. “You should see a doctor about that cough.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have,” he says, catching his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did he give you a Z-Pak?” Tommy’s eyes meet mine for a second, but he quickly looks away and I get a weird feeling in the pit of my stomach. “Babe?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s something we need to talk about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every cell in my body is suddenly standing at full attention. “Should I sit down for this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we both should.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He takes my hands in his and keeps holding them as we sit back down on the swing. The swing where I curl up with a novel on lazy Sunday mornings while Tommy reads the paper or does a crossword puzzle. The swing where I rocked CeCe to sleep when she was a baby. The swing where Tommy and I sometimes sit with a glass of wine, talking about our days and trying to solve the problems of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tighten my grip on his hand. “You’re scaring me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m scared, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Tommy doesn’t get scared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hold my breath. When he starts to speak, my world stops.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("T"), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("HE NEXT THIRTY")]), _vm._v(" minutes are the longest and slowest of my life. His words bounce around my head, refusing to stick: "), _c('i', [_vm._v("Small cell lung cancer. Stage 4. It’s not good.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lex?” he says my name as if it’s a lifeline, and I realize I haven’t said a word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could this happen? You’re too young.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("“And too good-looking,” he says, trying and failing to lighten the mood.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why didn’t you tell me something was wrong? I thought it was just a bad cough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The cough was just one symptom,” Tommy explains. “There were others, a little chest pain, shortness of breath. I didn’t want to worry you until there was something to worry about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Either he’s a better actor than CeCe, or I’ve been oblivious. But he didn’t say anything—I would have heard him; I would have noticed something was wrong. "), _c('i', [_vm._v("How long has he been pretending everything is okay?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long have you known?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They did a CT scan and a needle biopsy last week, but I didn’t get the results until Wednesday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You had a biopsy? How the hell did I miss that?” I feel myself starting to hyperventilate so I focus on breathing, inhaling and exhaling with purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were in New York for that big Dox presentation. I knew it was an important meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not more important than you,” I insist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy takes my hand and brings it gently to his mouth, forgiving me for what I didn’t know, what I didn’t do. “You needed your head in the game so you could impress that new bigwig. If you knew . . .” He stops and looks down at me, and I wish I could read his mind the way he always manages to read mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I knew, I would have been there.” I take my hand back and rest it in my lap, playing with a loose thread on the hem of my shirt. “You shouldn’t have had to go through that alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("“The whole thing took less than an hour, I was fine. Well, not that fine in hindsight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shake my head. I would be furious with him if I wasn’t so scared. I should have been with him, to hold his hand, to wait, to be nervous, to try to stay hopeful. He should have told me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why didn’t you tell me as soon as you knew?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tried,” Tommy says, and I feel sick to my stomach. The email. He said he’d wanted to talk. “But honestly, I didn’t try that hard.” There’s a raspiness to his voice I haven’t noticed before. I should have noticed. “I think I just needed to come to terms with it on my own first. I knew you’d have questions, and I wanted to have the answers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I need more than answers. I need to know that he’s going to be okay; he has to be okay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to talk to your doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have an appointment Monday to get a second opinion. But he’s going to say the same thing the first one did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what exactly was that?” I need him to say it again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s lung cancer, small cell. Stage 4B.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How many letters are there?” I knew about the numbers, but I didn’t know there were letters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("A and B.")]), _vm._v(" My heart sinks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It means the cancer has spread outside my chest,” Tommy explains in his shrink voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Spread? Where? How much?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pretty much everywhere. Lymph nodes. Liver. They even found a few spots in my bones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our conversation the other night flashes in my mind. “Your patient. You never tell me about your patients.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("He turns his face away from me and lowers his head.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you said . . .” I can’t finish the sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy looks at me with those eyes—one blue, one brown—that see right through me. They look sadder than I’ve ever seen them before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re going to fight this.” My voice is shaky, which I know makes me sound uncertain, so I say it again. “We are going to fight this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He squeezes my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say it.” I need to hear him say the words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lex.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say we’re going to fight this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s too late,” Tommy says. “The doctor may not use those words, but he’ll tell us the treatment would be tough. I’ll lose my hair.” I narrow my eyes at him. This is not the time for jokes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re going to fight this,” I say again, with more conviction this time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy’s face falls. “This is why I didn’t tell you before I made my own mind up; I knew you’d try to convince me. But the treatment wouldn’t just be hard on me, it would be hard on all of us. And chances are it won’t work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But there’s a chance it will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It won’t. And I’m not going to put you or CeCe through what I went through with my mom. The false hope, the pain and suffering.” His voice cracks with emotion. “I won’t do that to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What am I supposed to say to that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” Tommy says, soft as a whisper. He turns and looks at me, his eyes pleading. “That you’ll stay with me, that you’re not going anywhere?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("His desperation is palpable, and my heart is suddenly in my throat. How could he think for a second that I would leave?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I swing myself around so I’m facing him, one leg on each side, careful not to put too much weight on him. “Of course I’m not going anywhere,” I tell him. “I love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I kiss his neck on the left and then the right. I kiss his cheeks, where silent tears have started to fall. I kiss his mouth hungrily, as if I can make it all better. He kisses me back, but it feels like an apology so I pull away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you love me, you’ll fight to stay with me,” I plead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not that simple.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course it is. If you love me, if you love our daughter, if you love our life, you’ll fight to keep living it. You are not your mother; medicine has gotten so much more advanced since she was sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shhh.” He brings a finger to my lips. I hadn’t realized I’d raised my voice. “I’m not ready for CeCe to know. And we don’t have to solve everything tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like hell we don’t.” I slide off him and lean against the porch railing. I look into the Shulmans’ house across the street. Their lights are on and the drapes are open, so I can see Jenna and Corey in their living room, playing a game with their boys, Micah and Brett. Never in my life have I wanted so badly to trade lives with somebody, anybody else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My legs buckle, but Tommy’s there to catch me. He holds me up, his hands wrapped around my waist. His touch, which usually calms me, has the opposite effect tonight. Neither of us says anything as we sit back down on the swing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go to bed,” he eventually says. “We can talk more tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t get to control this,” I tell him, my voice sharper "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("than I intended. “And you’re the one who says we should never go to bed angry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please don’t be angry with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please don’t give up on me. On you. On us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sighs. “You don’t understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then make me.” I grasp his hands, as if he could explain it through osmosis. “In what world wouldn’t you want as much time with us as you can get?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even if I fight it, the doctor says I have six months, tops.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if you don’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Two to three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I inhale sharply and hold my breath, afraid I might throw up. Neither scenario gives us enough time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy turns my face toward his so I’m looking him in the eye. “If chemo or radiation could give me a few more years with you and Ceese, I’d do it in a heartbeat. But we’re talking months either way. And I want them to be good ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("T"), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("WENTY MINUTES LATER,")]), _vm._v(" my tears have dried, leaving salty tracks on my cheeks, but I’m nowhere closer to understanding. Tommy is staring straight ahead, not speaking. I don’t want to fight; I just want him to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know how else I can say it to make you understand. It’s quality over quantity,” he says, slipping into his shrink voice. “I’d rather have fewer good days than more miserable ones, when I’d be too sick to make the best of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what if—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are no ‘what if’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know everything, Tommy Whistler.” I’m aware "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("that my voice is getting louder again, but I can’t help it. “Doctors are wrong all the time; they might be wrong.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I lean back into the swing, trying to catch my breath again. It’s like someone stole all the oxygen and I can’t breathe. I can’t do this. Tommy puts his arm around me, rubbing circles on my back. The repetitive motion and the weight of his hand help calm me. I don’t want it to, but it does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not giving up on this,” I warn him. “I’m going to try to change your mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.” He pulls me closer so I can rest my head on his shoulder. The weight and unfairness of it all settles over me like a fog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did this happen? You look so healthy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, thank you,” Tommy says with a smile in his voice, but I don’t let his charm distract me. I need to find the logic in this, but there isn’t any, it doesn’t make sense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t even smoke.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Twenty percent of people with lung cancer never smoked.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sit back up so I can look him in the eye. “Please don’t quote statistics at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not even the one where people who tell their spouses they have less than six months to live have a hundred percent chance of getting laid that night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t try to make this a joke, it’s not funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s my cancer, I can joke if I want to,” he teases. “Wasn’t that a Patty Duke song?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lesley Gore,” I correct him. “‘It’s my party and I’ll cry if I want to.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please don’t cry anymore,” Tommy says. “I don’t want to remember your face all red and splotchy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I elbow his side and he bends forward, making a dreadful "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("sound. I jump up, causing the swing to sway in my wake. I steady it, afraid I accidentally hurt him. “I’m so sorry, are you okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy’s shoulders start to shake, and my stomach drops to my knees. When I realize he’s laughing, I step back and cross my arms. “I am so mad at you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looks up at me with that smile and those dimples and I realize I love him so much it hurts. I cringe when his laughter turns into another coughing fit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What can I do?” I plead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can forgive me,” he says, his voice strained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s nothing to forgive.” I reach for his hand, and we let ourselves back inside, where Tommy turns off the front porch light and locks the door as if it’s any other night. But it isn’t any other night. This is the night that will forever divide the before and the after.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When tomorrow comes, I’ll find a way to convince him we have to fight this. But tonight, I just want to close my eyes and drown myself in him, to forget everything except us. I want to pull him as close as he can get, until he’s a part of me. The best part of me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I catch a sob in my throat and he silences me with a kiss. There’s no apology in this one. It’s more urgent, as if he’s already trying to make up for the lifetime of kisses he won’t be here to give or receive. I taste the salt of tears; I’m just not sure if they’re his or they’re mine.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30bf3dba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062934864_Chapter_5.vue
// module id = 81
// module chunks = 0